module.exports = __webpack_public_path__ + "static/media/notice.878a3782.svg";